var _g, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame63(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 168,
    viewBox: "0 0 160 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_34384)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.916,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6563 0.154794C63.5995 0.103674 64.537 0.155428 65.4688 0.310055C65.9529 0.687023 66.3173 1.15281 66.5626 1.7074C66.771 4.91612 66.771 8.12487 66.5626 11.3336C65.6201 13.157 64.2138 13.6228 62.3438 12.7309C61.9685 12.4507 61.7079 12.0884 61.5626 11.6441C61.3541 8.22837 61.3541 4.81263 61.5626 1.39688C61.7782 0.822345 62.1426 0.408314 62.6563 0.154794Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.895,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.718 16.923C22.805 16.8249 23.8467 16.9802 24.843 17.3888C26.8743 19.4072 28.9055 21.4256 30.9368 23.444C31.8136 25.6966 31.0844 27.1458 28.7493 27.7913C28.2805 27.636 27.8118 27.4808 27.343 27.3255C25.2172 25.5241 23.186 23.6092 21.2493 21.5808C20.1287 19.9035 20.285 18.3509 21.718 16.923Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.899,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.595 16.9235C106.833 16.5422 108.031 17.8878 107.188 20.9603C105.053 23.0822 102.917 25.2041 100.782 27.326C97.7049 28.099 96.4027 26.9087 96.8758 23.755C98.9693 21.3129 101.209 19.0357 103.595 16.9235Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2188 23.1342C76.2282 22.0863 88.9885 28.8143 97.5001 43.3182C98.4051 45.1885 99.1863 47.1034 99.8438 49.0628C84.7888 57.0085 69.6847 64.8753 54.5313 72.6625C52.8244 74.5142 53.1369 75.9631 55.4688 77.0098C64.7738 78.6932 73.9926 80.6082 83.1251 82.7545C84.6401 84.8797 86.1504 87.0015 87.6563 89.1202C82.6641 94.732 79.956 101.305 79.5313 108.838C69.2188 108.838 58.9063 108.838 48.5938 108.838C48.1201 102.093 45.7763 96.0893 41.5626 90.8281C27.1406 78.428 23.1823 63.3158 29.6876 45.4918C35.5579 32.8235 45.4016 25.3709 59.2188 23.1342Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.966,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.469 24.6869C155.78 24.6776 155.989 24.8329 156.094 25.1527C149.475 46.072 143.017 67.0322 136.719 88.0334C128.177 86.4808 119.635 84.9282 111.094 83.3756C111.127 82.6667 111.388 82.0456 111.875 81.5125C119.66 70.6985 127.368 59.8303 135 48.9076C135.79 45.9664 134.696 44.8796 131.719 45.6472C115.781 56.3083 99.8438 66.9698 83.9062 77.6309C76.8978 76.528 69.9184 75.1825 62.9688 73.5942C93.97 57.52 124.803 41.2176 155.469 24.6869Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.944,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.969 56.9812C123.2 56.9405 123.408 56.9924 123.594 57.1364C117.358 65.8556 111.159 74.6021 105 83.3756C103.742 88.6417 102.544 93.9206 101.406 99.2122C96.8751 93.3123 92.3438 87.4124 87.8126 81.5124C87.6041 81.2019 87.6041 80.8914 87.8126 80.5809C99.5788 72.7455 111.298 64.879 122.969 56.9812Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.922,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84521 57.6015C8.3884 57.5496 11.9301 57.6015 15.4702 57.7567C17.1369 59.3094 17.1369 60.862 15.4702 62.4146C12.2641 62.9089 9.03496 63.0126 5.78271 62.7251C3.76277 62.1798 3.0857 60.8859 3.75146 58.8436C3.96699 58.2691 4.33159 57.8549 4.84521 57.6015Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.869,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.594 87.4121C111.213 87.9223 113.817 88.4915 116.406 89.12C113.229 92.0699 110.052 95.0199 106.875 97.9699C107.384 94.4551 107.957 90.9359 108.594 87.4121Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.897,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2798 92.3799C31.0139 92.7441 31.8995 94.1933 30.936 96.7272C28.9048 98.7456 26.8735 100.764 24.8423 102.782C21.7061 103.91 20.2999 102.823 20.6235 99.5219C22.8514 96.7368 25.4035 94.3564 28.2798 92.3799Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.932,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.719 103.248C103.323 102.915 104.521 103.433 105.312 104.801C105.039 107.422 104.779 110.061 104.531 112.719C104.492 115.605 105.274 118.244 106.875 120.638C109.085 122.626 111.064 124.799 112.812 127.159C114.247 131.206 113.31 134.622 110 137.406C109.012 139.348 109.481 140.952 111.406 142.219C113.569 143.681 115.704 145.183 117.812 146.721C119.697 148.902 119.645 151.024 117.656 153.087C116.888 153.572 116.055 153.883 115.156 154.019C108.682 154.331 102.223 154.848 95.7812 155.571C91.0831 156.454 86.3956 157.385 81.7187 158.366C75.5153 159.224 69.7859 157.982 64.5312 154.64C63.3572 153.682 62.4197 152.543 61.7188 151.224C65.7691 150.603 69.6231 151.121 73.2812 152.777C76.5091 153.386 79.7381 153.386 82.9687 152.777C92.3941 150.364 101.977 149.122 111.719 149.05C109.86 147.945 108.141 146.651 106.562 145.169C104.101 142.696 103.371 139.797 104.375 136.474C105.72 134.472 107.022 132.454 108.281 130.419C108.065 130.088 107.909 129.725 107.812 129.332C104.826 126.886 102.43 123.987 100.625 120.638C98.8656 115.508 98.7612 110.332 100.312 105.112C100.618 104.345 101.087 103.724 101.719 103.248Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.942,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7188 113.496C58.1775 113.444 69.636 113.496 81.0938 113.651C83.8944 114.399 84.9882 116.21 84.375 119.085C83.7838 120.19 82.8985 120.967 81.7188 121.414C69.8438 121.621 57.9688 121.621 46.0938 121.414C43.4197 119.951 42.7425 117.829 44.0625 115.049C44.8119 114.239 45.6972 113.721 46.7188 113.496Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.939,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4059 126.227C58.1772 126.176 69.9481 126.227 81.7184 126.383C84.585 127.787 85.2622 129.909 83.7497 132.748C83.1397 133.492 82.3584 133.958 81.4059 134.146C69.8434 134.353 58.2809 134.353 46.7184 134.146C43.5062 133.046 42.6209 130.924 44.0622 127.78C44.7403 127.059 45.5216 126.541 46.4059 126.227Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.966,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5311 138.959C60.8852 138.959 67.2396 138.959 73.5936 138.959C73.6455 140.722 73.5933 142.481 73.4374 144.238C73.0921 145.305 72.4149 146.081 71.4061 146.567C68.9583 146.619 66.5102 146.67 64.0624 146.722C61.3758 146.765 58.7196 146.61 56.0936 146.256C55.5067 145.777 55.038 145.208 54.6874 144.548C54.5314 142.688 54.4792 140.825 54.5311 138.959Z",
    fill: "#D11116"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 163.487,
    rx: 69,
    ry: 4.5,
    fill: "url(#paint0_radial_236_34384)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_236_34384",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80 163.487) scale(69 4.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_34384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 158.987,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame63);
export default __webpack_public_path__ + "static/media/Frame 63.dead10b7260afa3d41f4baa19026fcae.svg";
export { ForwardRef as ReactComponent };